import { JoinRule } from 'matrix-js-sdk/src/matrix';
import type { MatrixClient } from 'matrix-js-sdk/src/matrix';

import { getCanonicalParentRoom } from 'utils/roomHierarchyUtils';

export const getMessengerRoomTeamMeetingFlag = (matrixClient: MatrixClient, messengerRoomId: string): boolean => {
  const room = matrixClient.getRoom(messengerRoomId);
  if (!room) return true;

  const workspaceParent = getCanonicalParentRoom(room);
  if (!workspaceParent) return false;

  return room.getJoinRule() !== JoinRule.Public;
};
